var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { toBlob } from 'app/utils/canvas';
import { createCanvas, disposeCanvas } from 'app/utils/DOM';
import { disposeImage, loadImage } from 'app/utils/image';
export const PrimaryColor = '#3B82F6';
export const Logo = (props) => {
    const { width = '1em', height = '1em', backgroundType = 'fill' } = props, otherProps = __rest(props, ["width", "height", "backgroundType"]);
    return (React.createElement("svg", { width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024" },
        React.createElement("path", { d: "M174.5 62h675C911.632 62 962 112.368 962 174.5v675c0 62.132-50.368 112.5-112.5 112.5h-675C112.368 962 62 911.632 62 849.5v-675C62 112.368 112.368 62 174.5 62Z", fill: backgroundType === 'fill' ? PrimaryColor : 'none', stroke: backgroundType === 'fill' ? 'none' : otherProps.fill, strokeWidth: "3em" }),
        React.createElement("path", { d: "m893.39977,951.00411zm-423.205,-512.49l184.583,239.579l-247.845,52.681l63.262,-292.26zm491.253,380.314l-447.71,-580.956l-166.25,35.338l-152.397,688.449l161.867,0l20.28,-93.692l364.19,-77.41l65.23841,84.42l32.61921,42.21l32.61921,42.21c25.63815,-5.67442 44.72626,-17.90227 63.02556,-38.05501c18.2993,-20.15274 25.48265,-45.47583 26.51762,-72.18199l0,-30.332zl0,-30.332l0,30.332z", fill: backgroundType === 'fill' ? '#FFF' : otherProps.fill })));
};
export const OutlinedLogo = (props) => (React.createElement(Logo, Object.assign({ backgroundType: "outline" }, props)));
export const LogoInSvg = () => (React.createElement("div", { className: "logo svg" },
    React.createElement(Logo, { width: "30", height: "48", fill: PrimaryColor })));
export const LogoInHTML = () => (React.createElement("div", { className: "logo html" },
    React.createElement("div", null)));
// let WatermarkSource: string;
// const WatermarkBlob = new Blob([WatermarkSource], {
//     type: 'image/svg+xml',
// });
let WatermarkUrl; // = URL.createObjectURL(WatermarkBlob);
let watermark;
export function setWatermark(image) {
    const WatermarkBlob = new Blob([image], {
        type: 'image/svg+xml',
    });
    if (WatermarkUrl) {
        URL.revokeObjectURL(WatermarkUrl);
    }
    WatermarkUrl = URL.createObjectURL(WatermarkBlob);
}
export const loadWatermark = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!watermark) {
        const image = yield loadImage(WatermarkUrl);
        const { width, height } = image;
        const canvas = createCanvas({
            width,
            height,
        });
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0);
        disposeImage(image);
        const blob = yield toBlob(canvas, 'image/png');
        disposeCanvas(canvas);
        watermark = {
            image: { width, height, source: blob },
            url: URL.createObjectURL(blob),
        };
    }
    return watermark;
});
export const WatermarkInSvg = () => (React.createElement("img", { alt: "Annotely watermark", src: WatermarkUrl, style: { width: '120px', height: '24px' } }));
